import { render } from "./freelancertabset.vue?vue&type=template&id=9eb4422c"
import script from "./freelancertabset.vue?vue&type=script&lang=js"
export * from "./freelancertabset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__